import { createFileRoute, lazyRouteComponent, notFound } from '@tanstack/react-router';
import { oauthService } from '@/api/services/oauth';
import { checkFeatureGateOAuth } from '@/helpers/statsig/featureGate';

export const Route = createFileRoute('/_authenticated/_dashboard/security/connected-apps')({
  // The security layout already awaited `ensureStatsigUserFeatureGateReady`.
  beforeLoad: ({ context }) => {
    if (!checkFeatureGateOAuth(context.statsigClient)) {
      throw notFound();
    }

    return { myOAuthGrantsQuery: oauthService.listMyOAuthGrantsQuery() };
  },
  loader: ({ context: { queryClient, myOAuthGrantsQuery } }) => {
    void queryClient.prefetchQuery(myOAuthGrantsQuery);
  },
  staticData: {
    domain: 'iam',
  },
  component: lazyRouteComponent(() => import('./connected-apps.component'), 'SecurityConnectedAppsComponent'),
});
